<template>

  <v-container id="regular-tables" fluid tag="section">
     
  
  <v-container class="grey lighten-5" id="product__container">
  
    <div class="text-right">
       
       <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="fullPage"
      ></loading>
      </div>
      <v-row>
      
      <v-col cols="6">Duplicate PDF</v-col>
      <v-col cols="3">
        <div>
          Approved PDF <span>({{get_selected_product_id()}})</span>
        </div>
        <div v-if="selectedProductMeta" style="font-size: 12px; line-height: 1.4; margin-top: 6px;">
          <div>Text Similarity: {{ formatSimilarityPercent(selectedProductMeta.text_similarity) }}</div>
          <div>Visual Similarity: {{ formatSimilarityPercent(selectedProductMeta.visual_similarity) }}</div>
        </div>
      </v-col>
       <v-col cols="3">
      <v-select
            :items="product_ids"
            dense

            v-model="product_id_data"
            label="Product ID"
            @change="onProductSelectionChange"
          >
      </v-select>
       </v-col>
        </v-row>
        <v-row>
      <v-col cols="6">
            <iframe :src="duplicate_file" height="800" width="100%"></iframe>
      </v-col>

      <v-col cols="6">
          <iframe :src="product_file" height="800" width="100%"></iframe>
      </v-col>
        </v-row>   
          
          </v-container>      
 
  </v-container>
</template>
<script>

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    components: {Loading },
    data () {
      return {
        endpoints:{
          "GET_DATA_URL":null,
          "EXPORT_DATA_URL":null
         
        },
        get_data_api_url:null,
        data:[],
        item_key:"",
        totRecords :null,
        perpage:50,
        isLoading: true,
        product_id_data:'',
        fullPage: true,
        product_ids:[],
        page:1,
        headers: [
                {
                    text: 'Name',
                    align: 'start',                   
                    value: 'name',
                    width:"35%",
                     sortable: false,
                    class: "v-data-table-header ",
                },
                
                {
                    text: 'Logins',
                    value: 'lcount',
                     sortable: false,
                   
                    class: "v-data-table-header",
                },
                {
                    text: 'Login Time(HH:MM:SS)',
                    value: 'timediff',
                     sortable: false,
                    width:"15%",
                    class: "v-data-table-header",
                },
                
                

        ],
        showButtons:true,
        search_company_id:null,
        dialog:false,
        added_company_id:null,
        updatedialog:false,
        sender_email:null,
        update_item_id:'',
        company_name:'',
        show_add_delete_buttons:false,
        opendialog:false,
        show_check_box:false,
        editItem:false,
        showexportbutton:false,
        totalloginCount:'',
        totalTime:'',
        companyName:'',
        sdate:'',
        edate:'',
        duplicate_file:'',
        product_file:'',
        base_compare_product_id: '',
        product_similarity_scores: {},
        compare_request_token: 0,
        skip_next_route_compare: false,
        compare_product_ids_runtime: []
        
        
      }
    },
    mounted() {
      this.$store.dispatch("Rawdata/setDrawer", false)
      this.comparePdf();
    },
    computed: {
      selectedProductMeta() {
        const selectedValue = (this.product_id_data || "").toString().trim();
        if (!this.product_ids.length) return null;

        if (!selectedValue) return this.product_ids[0];

        const selectedValueProductId = this.extractProductIdFromFileUrl(selectedValue);
        return (
          this.product_ids.find((item) => {
            const itemValue = (item?.value || "").toString().trim();
            const itemText = (item?.text || "").toString().trim();
            const itemProductId = this.extractProductIdFromFileUrl(itemValue);

            return (
              itemValue === selectedValue ||
              itemText === selectedValue ||
              (selectedValueProductId && itemText === selectedValueProductId) ||
              (itemProductId && itemProductId === selectedValue)
            );
          }) || this.product_ids[0]
        );
      },
    },
    methods: {
      extractProductIdFromFileUrl(fileUrl = "") {
        const normalizedUrl = (fileUrl || "").toString().trim();
        if (!normalizedUrl) return "";

        const productPathMatch = normalizedUrl.match(/\/(?:current|Original)\/(\d+)\//i);
        if (productPathMatch && productPathMatch[1]) return productPathMatch[1];

        const fileNameMatch = normalizedUrl.match(/_(\d+)\.pdf(?:\?|$)/i);
        if (fileNameMatch && fileNameMatch[1]) return fileNameMatch[1];

        return "";
      },
      get_selected_product_id(){
        return this.selectedProductMeta?.text || "";
      },
      onProductSelectionChange() {
        if (!this.selectedProductMeta) {
          this.product_file = "";
          return;
        }
        this.product_file = this.selectedProductMeta.value;
      },
      formatSimilarityPercent(value) {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return "0.00%";
        return `${(numericValue * 100).toFixed(2)}%`;
      },
      checkIfOperationExistForModule(type){
        return this.$utils.checkIfOperationExistForModule(this, type)
    },
      normalizeProductIds(productIds = []) {
        return [...new Set(
          productIds
            .map((id) => (id === null || id === undefined ? "" : String(id).trim()))
            .filter((id) => /^\d+$/.test(id))
        )];
      },
      getCompareProductIdsFromStorage() {
        if (typeof window === "undefined") return this.compare_product_ids_runtime || [];
        try {
          const stored = window.sessionStorage.getItem("compare_pdf_product_ids");
          if (!stored) return this.compare_product_ids_runtime || [];
          return this.normalizeProductIds(String(stored).split(","));
        } catch (error) {
          console.warn("sessionStorage read blocked, using runtime compare IDs", error);
          return this.compare_product_ids_runtime || [];
        }
      },
      saveCompareProductIdsToStorage(productIds = []) {
        const normalized = this.normalizeProductIds(productIds);
        if (!normalized.length) return;
        this.compare_product_ids_runtime = normalized;
        if (typeof window === "undefined") return;
        try {
          window.sessionStorage.setItem("compare_pdf_product_ids", normalized.join(","));
        } catch (error) {
          console.warn("sessionStorage write blocked, keeping runtime compare IDs only", error);
        }
      },
      getCompareRequestConfig() {
        const routeParamId = (this.$route.params.id || "").toString().trim();
        const routeParamIds = this.normalizeProductIds(routeParamId.split(","));
        const queryProductIds = this.normalizeProductIds(
          ((this.$route.query && this.$route.query.product_ids) || "")
            .toString()
            .split(",")
        );
        const storedProductIds = this.getCompareProductIdsFromStorage();

        if (queryProductIds.length) {
          this.saveCompareProductIdsToStorage(queryProductIds);
          return { mode: "product_ids", productIds: queryProductIds, source: "query" };
        }

        if (routeParamIds.length > 1) {
          this.saveCompareProductIdsToStorage(routeParamIds);
          return { mode: "product_ids", productIds: routeParamIds, source: "route" };
        }

        if (storedProductIds.length && (!routeParamId || storedProductIds.includes(routeParamId))) {
          return { mode: "product_ids", productIds: storedProductIds, source: "storage" };
        }

        return { mode: "legacy", routeParamId, source: "legacy" };
      },
      getCompareEndpoint(compareRequest) {
        const compareBaseUrl = (this.$url("COMPARE_PDF") || "").replace(/\/$/, "");

        if (compareRequest.mode === "product_ids") {
          const idsCsv = compareRequest.productIds.join(",");
          const separator = compareBaseUrl.includes("?") ? "&" : "?";
          return `${compareBaseUrl}${separator}product_ids=${encodeURIComponent(idsCsv)}`;
        }

        const separator = compareBaseUrl.includes("?") ? "&" : "?";
        return `${compareBaseUrl}${separator}product_ids=${encodeURIComponent(compareRequest.routeParamId)}`;
      },
      getProcessedUploadPdfEndpoint(productId) {
        const compareBaseUrl = (this.$url("COMPARE_PDF") || "").replace(/\/+$/, "");
        const processedBaseUrl = compareBaseUrl.replace(/compare_pdf\/?$/i, "processed-upload-pdf");
        const separator = processedBaseUrl.includes("?") ? "&" : "?";
        return `${processedBaseUrl}${separator}product_id=${encodeURIComponent(productId)}`;
      },
      async fetchDuplicateSimilarityScores(productId) {
        const normalizedProductId = (productId || "").toString().trim();
        if (!/^\d+$/.test(normalizedProductId)) return {};

        const endpoint = this.getProcessedUploadPdfEndpoint(normalizedProductId);

        try {
          const response = await this.$fetch({
            requiresAuth: true,
            operation: "view",
            vueScope: this,
          }).get(endpoint);

          const duplicates = (((response || {}).data || {}).data || {}).DuplicateName || [];
          return (Array.isArray(duplicates) ? duplicates : []).reduce((acc, item) => {
            const duplicateProductId = (item?.product_id || "").toString().trim();
            if (!/^\d+$/.test(duplicateProductId)) return acc;

            acc[duplicateProductId] = {
              text_similarity: Number(item?.text_similarity) || 0,
              visual_similarity: Number(item?.visual_similarity) || 0,
            };
            return acc;
          }, {});
        } catch (error) {
          console.error("Failed to fetch processed-upload-pdf similarity data:", error);
          return {};
        }
      },
      sortProductFilesBySimilarity(productFiles = {}, similarityByProductId = {}) {
        const entries = Object.entries(productFiles).map(([key, value]) => {
          const productId = String(key || "").trim();
          const score = similarityByProductId[productId] || {};
          return {
            text: productId,
            value,
            text_similarity: Number(score.text_similarity) || 0,
            visual_similarity: Number(score.visual_similarity) || 0,
          };
        });

        return entries.sort((a, b) => {
          if (b.visual_similarity !== a.visual_similarity) {
            return b.visual_similarity - a.visual_similarity;
          }
          if (b.text_similarity !== a.text_similarity) {
            return b.text_similarity - a.text_similarity;
          }
          return Number(a.text) - Number(b.text);
        });
      },
      async comparePdf(){
        const currentToken = Date.now() + Math.random();
        this.compare_request_token = currentToken;
        var view = this
        view.isLoading = true
        this.product_ids = [];
        this.product_id_data = "";
        this.product_file = "";
        this.product_similarity_scores = {};

        const compareRequest = this.getCompareRequestConfig()
        if (
          compareRequest.mode === "legacy" &&
          (!compareRequest.routeParamId || !/^\d+$/.test(compareRequest.routeParamId))
        ) {
          view.isLoading = false
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Invalid compare product id!",
          });
          return;
        }

        const endpoint = this.getCompareEndpoint(compareRequest);
        console.log("Compare API endpoint", endpoint);
        const shouldCleanupQueryFromUrl =
          compareRequest.mode === "product_ids" && compareRequest.source === "query";

        try {
          const response = await this.$fetch({
            requiresAuth: true,
            operation: "view",
            vueScope: view,
          }).get(endpoint);
          if (this.compare_request_token !== currentToken) return;
          let compareResponseData = response.data || {};
          let preFetchedSimilarityByProductId = null;

          if (
            compareRequest.mode === "legacy" &&
            (
              !compareResponseData.duplicate_file ||
              !compareResponseData.product_ids ||
              !Object.keys(compareResponseData.product_ids || {}).length
            )
          ) {
            const legacyBaseProductId = (compareRequest.routeParamId || "").toString().trim();
            const compareBaseUrl = (this.$url("COMPARE_PDF") || "").replace(/\/$/, "");
            const separator = compareBaseUrl.includes("?") ? "&" : "?";
            const legacySimilarityByProductId = await this.fetchDuplicateSimilarityScores(legacyBaseProductId);
            if (this.compare_request_token !== currentToken) return;

            const fallbackProductIds = [...new Set(
              [legacyBaseProductId, ...Object.keys(legacySimilarityByProductId)]
                .map((id) => (id || "").toString().trim())
                .filter((id) => /^\d+$/.test(id))
            )];

            if (fallbackProductIds.length) {
              const fallbackEndpoint = `${compareBaseUrl}${separator}product_ids=${encodeURIComponent(fallbackProductIds.join(","))}`;
              const fallbackResponse = await this.$fetch({
                requiresAuth: true,
                operation: "view",
                vueScope: view,
              }).get(fallbackEndpoint);
              if (this.compare_request_token !== currentToken) return;
              compareResponseData = fallbackResponse.data || {};
              preFetchedSimilarityByProductId = legacySimilarityByProductId;
              this.saveCompareProductIdsToStorage(fallbackProductIds);
            }
          }

          if (compareResponseData.duplicate_file && (compareResponseData.product_file || compareResponseData.product_ids)) {
            this.duplicate_file = compareResponseData.duplicate_file

            const fallbackBaseProductId =
              compareRequest.mode === "product_ids"
                ? (compareRequest.productIds[0] || "")
                : (compareRequest.routeParamId || "");
            const responseProductId = (compareResponseData.product_id || "").toString().trim();
            const baseProductId = /^\d+$/.test(responseProductId)
              ? responseProductId
              : fallbackBaseProductId.toString().trim();
            this.base_compare_product_id = baseProductId;

            const similarityByProductId = (
              preFetchedSimilarityByProductId &&
              baseProductId === (compareRequest.routeParamId || "").toString().trim()
            )
              ? preFetchedSimilarityByProductId
              : await this.fetchDuplicateSimilarityScores(baseProductId);
            if (this.compare_request_token !== currentToken) return;
            this.product_similarity_scores = similarityByProductId;

            const sortedProductFiles = this.sortProductFilesBySimilarity(
              compareResponseData.product_ids || {},
              similarityByProductId
            );

            this.product_ids = sortedProductFiles;
            this.saveCompareProductIdsToStorage(Object.keys(compareResponseData.product_ids || {}));

            if (sortedProductFiles.length > 0) {
              this.product_id_data = sortedProductFiles[0].value;
              this.onProductSelectionChange();
            } else {
              this.product_file = "";
              this.product_id_data = "";
            }

            if (shouldCleanupQueryFromUrl) {
              const cleanId = compareRequest.productIds[0] || this.$route.params.id;
              this.skip_next_route_compare = true;
              this.$router
                .replace(`/compare_pdf/${encodeURIComponent(cleanId)}`)
                .catch(() => {});
            }
          }
        } catch (error) {
          if (this.compare_request_token !== currentToken) return;
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        } finally {
          if (this.compare_request_token === currentToken) {
            view.isLoading = false
          }
        }
      },  
    },
  watch: {
    '$route.fullPath': function() {
      if (this.skip_next_route_compare) {
        this.skip_next_route_compare = false;
        return;
      }
      this.comparePdf();
    },
    '$store.state.Rawdata.current_active_module': function(o) {
      if(o && !this.isLoading && !this.product_ids.length && !this.duplicate_file){
        this.$store.dispatch("Rawdata/setDrawer", false)
        this.comparePdf();
      }
    },

 },
  }
</script>
